__turbopack_context__.v({
  "chevron-down-icon": "ChevronDown-module-scss-module__4CsCMq__chevron-down-icon",
});
